export const workflowsAppDefaults = {
  shouldCollapseFlowsWithBranches: false,
  shouldScrollHorizontally: true,
  shouldAllowZoom: true,
  shouldAllowCommenting: true
};